import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { lteManageInventoryService } from 'src/app/services/lteManageInventory.service';

interface TopupHistory {
  ApplicationRef:string,
  CustomerRef:string,
  productName: string;
  purchaseDate: Date | null;
  expieryDate:Date|null;   
  transactionId: string;
  price: number;
  paymentType: string;
}

@Component({
  selector: 'app-ltetopuphistory',
  templateUrl: './ltetopuphistory.component.html',
  styleUrls: ['./ltetopuphistory.component.scss']
})


export class LtetopuphistoryComponent implements OnInit {
  data :any = [];
  dataSource = new MatTableDataSource(this.data);
displayedColumns: string[] = [
    "ApplicationRef",
    "CustomerReference",
    "TopupPlan",
    "PurchasedDate",
    "ExpierDate",
    "TransactionId",
    "PaymentType",
    "Price"
  ];
  dataExcel: any;
  constructor(private Ltedataservice:lteManageInventoryService) { }
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
ngOnInit(): void {
    this.getTableData("")
    // this.dataSource = new MatTableDataSource(this.data);

  }

  getTableData(data){
    if (data) {
      data = { searchQuery: this.searchInput.nativeElement.value.trim() }
    }
    this.Ltedataservice.LTETopupHistory(data).subscribe((result:any) => {
      console.log(result)
      this.data = [];
      this.dataExcel = [];
      this.data = result.map((item: any) => ({
          ApplicationRef:item.referenceNumber,
          CustomerRef:item.customerReference,
          productName: item.product.aliasName,               
          purchaseDate: item.creationTs ? new Date(item.creationTs) : null,
          expieryDate: item.expieryDate? new Date(item.expieryDate) : null,
          transactionId: item?.paymentApplicationMapping?.checkoutId,
          price: item.product.cost,
          paymentType: item.paymentApplicationMapping.paymentType
        })) as TopupHistory[];


      this.dataExcel = result;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }

clearFilter(){
  this.searchInput.nativeElement.value = "";
this.getTableData("")
}


}
